// extracted by mini-css-extract-plugin
module.exports = {"parties":"search_filters_parties-module__parties--zBvPK","text":"search_filters_parties-module__text--Qtk41"};